import { render } from "./SolidaryTransport.view.vue?vue&type=template&id=357e88fd"
import script from "./SolidaryTransport.view.vue?vue&type=script&lang=js"
export * from "./SolidaryTransport.view.vue?vue&type=script&lang=js"

import "./SolidaryTransport.view.vue?vue&type=style&index=0&id=357e88fd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__